<template>
  <div id="app">
    <router-view />
    <v-overlay :value="loading" z-index="205">
      <v-progress-circular
        color="#01579B"
        indeterminate
        size="90"
        width="7"
      ></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import dayjs from "dayjs";
import * as actions from "@/store/types";
import * as getters from "@/store/getters";
import { mapActions, mapGetters } from "vuex";
import { EventBus } from "@/tools/event-bus";
import { loadLocaleMessagesAsync } from "@/plugins/i18n.js";
import { setDocumentLang } from "@/tools/i18nUtils.js";

export default {
  name: "app",
  data() {
    return {
      loading: true,
    };
  },
  computed: {
    ...mapGetters({
      expireAt: [getters.EXPIRE_AT],
      hasRefreshToken: [getters.HAS_REFRESH_TOKEN],
      isAuthenticated: [getters.IS_AUTHENTICATED],
    }),
  },
  methods: {
    ...mapActions([actions.AUTH_REFRESH, actions.AUTH_LOGOUT]),
    checkAppVersion() {
      const APP_VERSION = process.env.VUE_APP_CURRENT_GIT_SHA;

      if (APP_VERSION) {
        if (
          !localStorage.hasOwnProperty("APP_VERSION") ||
          localStorage.getItem("APP_VERSION") === null
        ) {
          localStorage.setItem("APP_VERSION", APP_VERSION);
        }

        if (localStorage.getItem("APP_VERSION") !== APP_VERSION) {
          localStorage.clear();
          location.reload();
        }
      }
    },
    async loadLocaleMessages(locale) {
      this.displayLoader();
      await loadLocaleMessagesAsync(locale);
      setDocumentLang(locale);
      dayjs.locale(locale);
      this.hideLoader();
    },
    async refreshToken() {
      if (
        undefined !== this.expireAt &&
        dayjs().add(15, "m").isAfter(this.expireAt)
      ) {
        try {
          await this[actions.AUTH_REFRESH]();
        } finally {
          EventBus.$on("stop-loading", this.hideLoader);
        }
      }
    },
    displayLoader() {
      this.loading = true;
    },
    hideLoader() {
      this.loading = false;
    },
    async on401Error() {
      localStorage.removeItem("impersonate");

      if (this.hasRefreshToken) {
        await this[actions.AUTH_REFRESH]();
        this.$router.go();
        return;
      }

      if (this.isAuthenticated) {
        await this[actions.AUTH_LOGOUT]();
      }

      await this.$router.push("/login");
    },
  },
  created() {
    this.checkAppVersion();

    EventBus.$on("401-error", this.on401Error);
    EventBus.$on("start-loading", this.displayLoader);
    EventBus.$on("stop-loading", this.hideLoader);

    this.loadLocaleMessages(this.$i18n.locale);

    setInterval(this.refreshToken, 600000);
  },
};
</script>
